import { Link } from 'react-router'
import { siteConfig } from '../../config/site'

type FooterLink = { label: string; href: string; external?: boolean }
const shopLink = (path: string) => new URL(path, siteConfig.onlinePrintShopUrl).href
const groups: { title: string; links: FooterLink[] }[] = [
  { title: 'Local Services', links: [
    { label: 'Copy & Print', href: '/services/copy-print' },
    { label: 'Shipping', href: '/services/shipping' },
    { label: 'Packing', href: '/services/packing' },
    { label: 'Mailbox Services', href: '/Home-Business/Mailbox-Rental' },
    { label: 'Notary', href: '/Home-Business/Notary-Public' },
    { label: 'Document Scanning', href: '/Home-Business/Document-Scanning' },
  ] },
  { title: 'Digital & Marketing', links: [
    { label: 'Website Design & Hosting', href: '/digital-marketing/websites' },
    { label: 'Domains & Business Email', href: '/digital-marketing/business-email' },
    { label: 'SEO & Digital Marketing', href: '/digital-marketing/seo' },
    { label: 'Social Media Marketing', href: '/digital-marketing/social-media' },
    { label: 'Logo & Branding', href: '/digital-marketing/custom?service=Branding' },
    { label: 'Digital Marketing Packages', href: '/digital-marketing/packages' },
  ] },
  { title: 'Online & Support', links: [
    { label: 'Order Online', href: siteConfig.onlinePrintShopUrl, external: true },
    { label: 'Upload Files', href: '/file-upload' },
    { label: 'Custom Quote', href: shopLink('/custom-quote'), external: true },
    { label: 'Package Tracking', href: '/Tracking' },
    { label: 'Track Print Order', href: shopLink('/track-order'), external: true },
    { label: 'Help Center', href: shopLink('/help'), external: true },
  ] },
  { title: 'Company', links: [
    { label: 'About Us', href: '/about-us' },
    { label: 'Contact', href: '/contact-us' },
    { label: 'Special Offers', href: '/coupons' },
    { label: 'Privacy Policy', href: '/Privacy-Policy' },
    { label: 'Terms', href: '/Terms' },
  ] },
]
const partners: FooterLink[] = [
  { label: 'Arina Technologies', href: 'https://arinatechnologies.com', external: true },
  { label: 'CloudMySite', href: 'https://cloudmysite.com', external: true },
  { label: 'CloudMySite AI', href: 'https://cloudmysite.ai', external: true },
]
function FooterAnchor({ link }: { link: FooterLink }) {
  return link.external ? <a href={link.href} target="_blank" rel="noopener noreferrer">{link.label} <span aria-hidden="true">↗</span><span className="sr-only"> (opens in a new tab)</span></a> : <Link to={link.href}>{link.label}</Link>
}
export function SiteFooter() {
  const [street, suite] = siteConfig.address.street.split(', ')
  return (
    <footer className="site-footer site-footer--expanded">
      <div className="inner-shell site-footer__grid">
        <section className="site-footer__business" aria-labelledby="footer-business-title">
          <h2 id="footer-business-title">Pack Print Mail</h2>
          <address><strong>{siteConfig.legalName}</strong><span>{street}</span>{suite && <span>{suite}</span>}<span>{siteConfig.address.locality}, {siteConfig.address.region} {siteConfig.address.postalCode}</span></address>
          <a href={siteConfig.phoneHref}>{siteConfig.phone}</a>
          <a href={`mailto:${siteConfig.email}`}>{siteConfig.email}</a>
          <Link to="/contact-us#store-hours">Store Hours</Link>
          <FooterAnchor link={{ label: 'Directions', href: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(siteConfig.address.formatted)}`, external: true }} />
        </section>
        {groups.map((group, index) => (
          <nav key={group.title} aria-labelledby={`footer-group-${index}`}>
            <h2 id={`footer-group-${index}`}>{group.title}</h2>
            <ul>{group.links.map((link) => <li key={link.href}><FooterAnchor link={link} /></li>)}</ul>
            {group.title === 'Digital & Marketing' && <section className="site-footer__partnership" aria-labelledby="footer-partnership-title">
              <h3 id="footer-partnership-title">Technology partnership</h3>
              <p>Digital services delivered by Pack Print Mail in partnership with Arina Technologies.</p>
              <p>Websites, hosting and AI-powered business solutions supported by CloudMySite.</p>
              <ul>{partners.map((link) => <li key={link.href}><FooterAnchor link={link} /></li>)}</ul>
            </section>}
          </nav>
        ))}
      </div>
      <div className="site-footer__bottom"><div className="inner-shell">
        <div className="site-footer__statement"><p className="site-footer__tagline">Print. Pack. Ship. Market. Grow.</p><p>Local printing, shipping, mailbox and business services in Waxahachie, Texas — plus websites, digital marketing and AI-powered business solutions.</p></div>
        <div className="site-footer__copyright"><p>© {new Date().getFullYear()} {siteConfig.legalName}</p><p>Digital services in partnership with Arina Technologies</p></div>
      </div></div>
    </footer>
  )
}
